import React from 'react'
import { IonIcon } from '@ionic/react'

export const ImageOffIcon = (props: { slot?: string; className?: string }) => {
  return <IonIcon src={'/assets/icons/imageOff.svg'} {...props} />
}

export default ImageOffIcon
